export default __webpack_public_path__ + "static/media/image.anybanq-lk.efc1f42a.png";